const api = {
  queryTag: '/api/labelComplex/manager/query', // 查询标签
  queryCompanyConfig: '/api/companyConfig/manager/query', // 查询企业配置
  // modifyCompanyConfig:'/api/companyConfig/manager/modifyCompanyConfig', //编辑和新增企业配置
  modifyCompanyConfig: '/api/companyConfig/manager/saveCompanyConfig', // 编辑和新增企业配置
};

export default api;
